import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Payment, CreatePaymentDto, PaymentFilter, PaymentPagedResult } from '../models/payment.model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PaymentsService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.apiUrl}/payments`;

  getFiltered(filter: PaymentFilter): Observable<PaymentPagedResult> {
    let params = new HttpParams();
    if (filter.supplierId) params = params.set('supplierId', filter.supplierId);
    if (filter.fromDate) params = params.set('fromDate', filter.fromDate);
    if (filter.toDate) params = params.set('toDate', filter.toDate);
    if (filter.page) params = params.set('page', filter.page.toString());
    if (filter.pageSize) params = params.set('pageSize', filter.pageSize.toString());

    return this.http.get<PaymentPagedResult>(this.apiUrl, { params });
  }

  getById(id: string): Observable<Payment> {
    return this.http.get<Payment>(`${this.apiUrl}/${id}`);
  }

  getBySupplierId(supplierId: string): Observable<Payment[]> {
    return this.http.get<Payment[]>(`${this.apiUrl}/supplier/${supplierId}`);
  }

  create(dto: CreatePaymentDto): Observable<Payment> {
    return this.http.post<Payment>(this.apiUrl, dto);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
